const isServerSideRendering = (function serverSideRenderCheck() {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
})();

export default isServerSideRendering;
